"use client";
console.warn("⚠️ Avoid importing components from 'index.js' for better performance. This practice is deprecated and may be removed in the future.");
import * as __Builtin from "./_Builtin/index.js";
export { __Builtin as _Builtin };
export * from "./devlinkContext";
export * from "./interactions";
export * from "./utils";
export * from "./devlink";
export * from "./AiAgents";
export * from "./AiTeamsImpact";
export * from "./CaseStudies";
export * from "./Closer";
export * from "./Departments";
export * from "./DepartmentsProjectsTest";
export * from "./DevLinkProvider";
export * from "./Hero";
export * from "./HeroFu";
export * from "./Logos";
export * from "./Magic";
export * from "./MondayDifference";
export * from "./Products";
export * from "./Security";
export * from "./Trust";
